import { CanActivateFn } from '@angular/router';
import { ArtActivatedRouteSnapshot } from '@utils/interfaces';
import { inject } from '@angular/core';
import { PermissionService } from '@services/permission.service';
import { MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { UserStore } from '@stores/user.store';
import { NavigationService } from '@services/navigation.service';

export const AuthorityGuard: CanActivateFn = async (route: ArtActivatedRouteSnapshot) => {
  const authService = inject(MsalService);
  const userStore = inject(UserStore);
  const permissionService = inject(PermissionService);
  const navigationService = inject(NavigationService);

  if (!userStore.user()) {
    await firstValueFrom(authService.initialize());
    await userStore.fetchUserInformation();
  }
  const authorities = route.data?.authorities;
  if (!authorities) return true;

  const hasAccess = permissionService.hasAuthority(authorities);
  if (!hasAccess) await navigationService.navigateToHome();

  return hasAccess;
};
